export default {"src":"/_next/static/media/skills.75465667.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};